/* eslint-disable max-params */
/* eslint-disable max-lines */

import { AddToCartRequestTO } from './use-add-to-cart';
import { UpdateToQuoteRequestTO } from './use-update-to-quote';
import { UpdateToCartRequestTO } from './use-update-to-cart';
import { parseJSON } from '../../AddToQuote/internal/parseJSON';

export const getDate = (date: string) => {
  const [day, month, year] = date.split('/');
  const newDate = `${month}/${day}/${year}`;
  return newDate;
};

export const getDateV3 = (date: string) => {
  const [year, month, day] = date.split('-');
  const newDate = `${month}/${day}/${year}`;
  return newDate;
};

export function getFormatedDate(
  date: string,
  formatDate: (date: Date, format?: string | undefined) => string
) {
  return date === null || date === '' || date === undefined
    ? ''
    : formatDate(new Date(getDate(date)));
}

export function isEverestSku(
  everestVendors: any,
  blackListedVendors: any,
  vendorCode: string
) {
  const everestVendorsList = everestVendors
    ?.split(',')
    ?.map(function (item: string) {
      return item.trim();
    });
  const blackListedVendorsList = blackListedVendors
    ?.split(',')
    ?.map(function (item: string) {
      return item.trim();
    });
  if (
    everestVendorsList?.includes(vendorCode) ||
    everestVendorsList?.includes('*')
  ) {
    if (blackListedVendorsList?.includes(vendorCode)) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
}

export const getDateCartStock = (date: string) => {
  const [day, month, year] = date.split('/');
  const newDate = `${day}/${month}/${year}`;
  return newDate;
};

export const getRelatedCacheKeys = (queryClient: any, targetKey: any) => {
  return queryClient
    .getQueryCache()
    .getAll()
    .map((query: any) => query.queryKey)
    .filter((key: any) =>
      Array.isArray(key) ? key.includes(targetKey) : key === targetKey
    );
};

export type QuantityData = {
  isQuantityChange: boolean;
  pricePerQuantity: number;
  qty: number;
};

export const emeaCountries = [
  'es',
  'se',
  'gb',
  'fr',
  'ch',
  'it',
  'hu',
  'de',
  'at',
  'pt',
  'dk',
  'fi',
  'uk',
  'in',
];

export const IsResellerDeal = (bidData: any, siteCode: string) => {
  if (
    bidData?.additionalAttributes !== undefined &&
    bidData?.additionalAttributes !== null
  ) {
    const euMandatoryForClaims = bidData.additionalAttributes.find(
      (item: any) => item.attributename === 'euMandatoryForClaims'
    );
    return (
      euMandatoryForClaims !== undefined &&
      (euMandatoryForClaims.attributevalue === 'N' ||
        euMandatoryForClaims.attributevalue === '') &&
      emeaCountries.indexOf(siteCode) !== -1
    );
  }
  return false;
};

export const getEndUserRequire = (bidData: any) => {
  if (
    bidData?.additionalAttributes !== undefined &&
    bidData?.additionalAttributes !== null
  ) {
    const euMandatoryForClaims = bidData.additionalAttributes.find(
      (item: any) => item.attributename === 'euMandatoryForClaims'
    );
    return (
      euMandatoryForClaims !== undefined &&
      (euMandatoryForClaims.attributevalue === 'Y' ||
        euMandatoryForClaims.attributevalue === 'R')
    );
  }
  return false;
};

export const getEuMandatoryForClaims = (bidData: any) => {
  if (
    bidData?.additionalAttributes !== undefined &&
    bidData?.additionalAttributes !== null
  ) {
    const euMandatoryForClaims = bidData.additionalAttributes.find(
      (item: any) => item.attributename === 'euMandatoryForClaims'
    );
    return euMandatoryForClaims.attributevalue !== undefined
      ? euMandatoryForClaims.attributevalue
      : '';
  }
  return '';
};

const getSpecialBidInfo = (
  bidData: any,
  vendorCode: string,
  quantityData: QuantityData
) => {
  return {
    acopTrackingNumber: bidData.productLines[0].acopTrackingNumber,
    bidEndCustomer:
      bidData.AffiliatedEndUserData === null ||
      bidData.AffiliatedEndUserData === undefined
        ? bidData.endUser.vendorEndUserName
        : bidData.AffiliatedEndUserData?.endUserAffiliationName,
    bidIdentity: bidData.bidId.toString(),
    bidNumber: bidData.bidNumber,
    dealDiscountType: bidData.vendorDiscountType,
    discountProgram: bidData.vendorProgramName,
    discountProgramId: bidData.vendorProgramId?.toString(),
    euMandatoryForClaims: getEuMandatoryForClaims(bidData),
    expirationDate: bidData.productLines[0].expirationDate,
    isEndUserRequire: getEndUserRequire(bidData),
    masterContract: bidData.masterContract,
    maxQuantity:
      bidData.productLines[0].specialBidAvaibilityInformation.maxQuantity,
    minQuantity:
      bidData.productLines[0].specialBidAvaibilityInformation.minQuantity,
    price:
      quantityData.isQuantityChange === false
        ? bidData.productLines[0].price
        : quantityData.pricePerQuantity,
    productSetBundleIdField: bidData.productLines[0].productSetBundleId,
    productSetId: bidData.productLines[0].productSetId,
    productSetSequence: bidData.productLines[0].productSetSequence,
    remainQuantity:
      bidData.productLines[0].specialBidAvaibilityInformation.remainingQuantity,
    startDate: bidData.productLines[0].startDate,
    vendorCode: vendorCode,
    vendorDealType: bidData.vendorProgramName,
  };
};

const getEndUser = (bidData: any) => {
  return bidData.AffiliatedEndUserData === null ||
    bidData.AffiliatedEndUserData === undefined
    ? {
        city: bidData.endUser.cityName,
        companyName: bidData.endUser.vendorEndUserName,
        countryCode: bidData.endUser.country,
        countryName: bidData.endUser.country,
        email: bidData.endUser.email,
        endUserAcopId:
          bidData.endUser.endUserNumber === null ||
          bidData.endUser.endUserNumber === '' ||
          bidData.endUser.endUserNumber === undefined
            ? null
            : bidData.endUser.endUserNumber.trim(),
        endUserAddressSeqId: bidData.endUser.endUserAddressSeqId,
        endUserAffiliationId: 0,
        endUserContactId: bidData.endUser.endUserContactId,
        endUserNumber: bidData.endUser.endUserId,
        faxNumber: '',
        firstName: bidData.endUser.firstName,
        fullAddress: bidData.endUser.fullAddress,
        fullName: bidData.endUser.fullName,
        ingramEndUserId: bidData.endUser.endUserId,
        isNewEndUser: false,
        lastName: bidData.endUser.lastName,
        line1: bidData.endUser.addressLine1,
        line2: bidData.endUser.addressLine2,
        line3: bidData.endUser.addressLine3,
        phoneNumber: bidData.endUser.phone,
        postalCode: bidData.endUser.postalCode,
        stateName: bidData.endUser.stateName,
      }
    : {
        city: bidData.AffiliatedEndUserData.city,
        companyName: bidData.AffiliatedEndUserData.endUserAffiliationName,
        countryCode: bidData.AffiliatedEndUserData.country,
        countryName: bidData.AffiliatedEndUserData.country,
        email: '',
        endUserAcopId: '',
        endUserAddressSeqId: '',
        endUserAffiliationId:
          bidData.AffiliatedEndUserData.endUserAffiliationId,
        endUserContactId: '',
        endUserNumber:
          bidData.AffiliatedEndUserData.endUserID !== 0
            ? bidData.AffiliatedEndUserData.endUserID?.toString()
            : '',
        faxNumber: '',
        firstName: '',
        fullAddress: '',
        fullName: '',
        ingramEndUserId:
          bidData.AffiliatedEndUserData.endUserID !== 0
            ? bidData.AffiliatedEndUserData.endUserID?.toString()
            : '',
        isNewEndUser: false,
        lastName: '',
        line1: '',
        line2: '',
        line3: '',
        phoneNumber: '',
        postalCode: bidData.AffiliatedEndUserData.postalCode,
        stateName: bidData.AffiliatedEndUserData.state,
      };
};

const getBidSliderEndUser = (bidData: any, endUser: any) => {
  return bidData.AffiliatedEndUserData === null ||
    bidData.AffiliatedEndUserData === undefined
    ? {
        city: bidData.endUser.cityName,
        companyName: bidData.endUser.vendorEndUserName,
        countryCode: bidData.endUser.country,
        countryName: bidData.endUser.country,
        email: bidData.endUser.email,
        endUserAcopId: endUser?.EndUserAcopId,
        endUserAddressSeqId: endUser?.AddressSequenceId || '0',
        endUserAffiliationId: 0,
        endUserContactId: endUser?.ContactId || '0',
        endUserNumber: endUser?.IngramEndUserId || '0',
        faxNumber: '',
        firstName: bidData.endUser.firstName,
        fullAddress: bidData.endUser.fullAddress,
        fullName: bidData.endUser.fullName,
        ingramEndUserId: endUser?.IngramEndUserId || '0',
        isNewEndUser: false,
        lastName: bidData.endUser.lastName,
        line1: bidData.endUser.addressLine1,
        line2: bidData.endUser.addressLine2,
        line3: bidData.endUser.addressLine3,
        phoneNumber: bidData.endUser.phone,
        postalCode: bidData.endUser.postalCode,
        stateName: bidData.endUser.stateName,
      }
    : {
        city: bidData.AffiliatedEndUserData.city,
        companyName: bidData.AffiliatedEndUserData.endUserAffiliationName,
        countryCode: bidData.AffiliatedEndUserData.country,
        countryName: bidData.AffiliatedEndUserData.country,
        email: '',
        endUserAcopId: '',
        endUserAddressSeqId: '',
        endUserAffiliationId:
          bidData.AffiliatedEndUserData.endUserAffiliationId,
        endUserContactId: '',
        endUserNumber:
          bidData.AffiliatedEndUserData.endUserID !== 0
            ? bidData.AffiliatedEndUserData.endUserID?.toString()
            : '',
        faxNumber: '',
        firstName: '',
        fullAddress: '',
        fullName: '',
        ingramEndUserId:
          bidData.AffiliatedEndUserData.endUserID !== 0
            ? bidData.AffiliatedEndUserData.endUserID?.toString()
            : '',
        isNewEndUser: false,
        lastName: '',
        line1: '',
        line2: '',
        line3: '',
        phoneNumber: '',
        postalCode: bidData.AffiliatedEndUserData.postalCode,
        stateName: bidData.AffiliatedEndUserData.state,
      };
};

export const updateData = (
  bidData: any,
  lineId: string,
  isSplitLineConfirm: boolean,
  vendorCode: string,
  quantityData: QuantityData
) => {
  const param: UpdateToCartRequestTO = {
    isAgreedWithSplitLine: isSplitLineConfirm,
    lineItemId: lineId,
    // eslint-disable-next-line sort-keys
    basketLineSpecialBidInformation: getSpecialBidInfo(
      bidData,
      vendorCode,
      quantityData
    ),
    endUserInfo: getEndUser(bidData),
    quantity: quantityData.qty ?? 0,
  };

  return param;
};

export const updateBidSliderData = (
  bidData: any,
  endUser: any,
  lineId: string,
  isSplitLineConfirm: boolean,
  vendorCode: string,
  quantityData: QuantityData
) => {
  const param: UpdateToCartRequestTO = {
    isAgreedWithSplitLine: isSplitLineConfirm,
    lineItemId: lineId,
    // eslint-disable-next-line sort-keys
    basketLineSpecialBidInformation: getSpecialBidInfo(
      bidData,
      vendorCode,
      quantityData
    ),
    endUserInfo: getBidSliderEndUser(bidData, endUser),
    quantity: quantityData.qty ?? 0,
  };

  return param;
};

export const addData = (
  bidData: any,
  sku: string,
  vendorCode: string,
  quantityData: QuantityData
) => {
  const param: AddToCartRequestTO = {
    productSku: sku,
    quantity: quantityData.qty ?? 0,
    specialBid: getSpecialBidInfo(bidData, vendorCode, quantityData),
    // eslint-disable-next-line sort-keys
    endUserInfo: getEndUser(bidData),
  };
  return param;
};

export const addBidSliderData = (
  bidData: any,
  endUser: any,
  sku: string,
  vendorCode: string,
  quantityData: QuantityData
) => {
  const param: AddToCartRequestTO = {
    productSku: sku,
    quantity: quantityData.qty ?? 0,
    specialBid: getSpecialBidInfo(bidData, vendorCode, quantityData),
    // eslint-disable-next-line sort-keys
    endUserInfo: getBidSliderEndUser(bidData, endUser),
  };
  return param;
};

export const deleteData = (bidData: any, qty: number, lineId: string) => {
  const param: UpdateToCartRequestTO = {
    isAgreedWithSplitLine: false,
    lineItemId: lineId,
    // eslint-disable-next-line sort-keys
    basketLineSpecialBidInformation: {
      acopTrackingNumber: '', //bidData.productLines[0].acopTrackingNumber,
      bidEndCustomer: '',
      bidIdentity: '', //'', //bidData.bidId.toString(),
      bidNumber: '',
      dealDiscountType: '',
      discountProgram: '',
      discountProgramId: '',
      expirationDate: bidData.expirationDate, //bidData.productLines[0].expirationDate,
      isEndUserRequire: false,
      masterContract: '',
      maxQuantity: 0,
      minQuantity: 0,
      price: 0, //bidData.productLines[0].price,
      productSetBundleIdField: 0,
      productSetId: 0,
      productSetSequence: 0,
      remainQuantity: 0,
      startDate: bidData.startDate,
      vendorCode: '',
      vendorDealType: '',
    },
    endUserInfo: {
      city: '',
      companyName: '',
      countryCode: '',
      countryName: '',
      email: '',
      endUserAcopId: '',
      endUserAddressSeqId: '',
      endUserAffiliationId: 0,
      endUserContactId: '',
      endUserNumber: '',
      faxNumber: '',
      firstName: '',
      fullAddress: '',
      fullName: '',
      ingramEndUserId: '',
      isNewEndUser: false,
      lastName: '',
      line1: '',
      line2: '',
      line3: '',
      phoneNumber: '',
      postalCode: '',
      stateName: '',
    },
    quantity: qty ?? 0,
  };

  return param;
};

export const updateQuoteData = (
  bidData: any,
  qty: number,
  basketLineId: string,
  quoteNumber?: string,
  vendorCode?: string,
  everestEndUserId?: string
) => {
  const isUnlimitedQty = bidData.productLines[0]?.additionalAttributes?.find(
    (attrib: any) => attrib.attributename === 'IsUnlimitedQuantity'
  )?.attributevalue;
  const param: UpdateToQuoteRequestTO = {
    basketLineSpecialBidInformation: {
      acopTrackingNumber: bidData.productLines[0].acopTrackingNumber,
      bidEndCustomer: bidData.endUser.vendorEndUserName,
      bidIdentity: bidData.bidId.toString(),
      bidNumber: bidData.bidNumber,
      dealDiscountType: bidData.vendorDiscountType,
      discountProgramId: bidData.vendorProgramId?.toString(),
      euMandatoryForClaims: getEuMandatoryForClaims(bidData),
      expirationDate: bidData.productLines[0].expirationDate,
      isEndUserRequire: getEndUserRequire(bidData),
      isUnlimitedQuantity: isUnlimitedQty,
      masterContract: bidData.masterContract,
      maxQuantity:
        bidData.productLines[0].specialBidAvaibilityInformation.maxQuantity,
      minQuantity:
        bidData.productLines[0].specialBidAvaibilityInformation.minQuantity,
      price: bidData.productLines[0].price,
      productSetBundleIdField: bidData.productLines[0].productSetBundleId,
      productSetId: bidData.productLines[0].productSetId,
      productSetSequence: bidData.productLines[0].productSetSequence,
      remainQuantity:
        bidData.productLines[0].specialBidAvaibilityInformation
          .remainingQuantity,
      startDate: bidData.productLines[0].startDate,
      vendorCode,
      vendorDealType: bidData.vendorProgramName,
    },
    endUserInfo:
      bidData.AffiliatedEndUserData === null ||
      bidData.AffiliatedEndUserData === undefined
        ? {
            city: bidData.endUser.cityName,
            companyName: bidData.endUser.vendorEndUserName,
            countryCode: bidData.endUser.country,
            countryName: bidData.endUser.country,
            email: bidData.endUser.email,
            endUserAcopId:
              bidData.endUser.endUserNumber === null ||
              bidData.endUser.endUserNumber === '' ||
              bidData.endUser.endUserNumber === undefined
                ? null
                : bidData.endUser.endUserNumber.trim(),
            endUserAddressSeqId: bidData.endUser.endUserAddressSeqId,
            endUserAffiliationId: '',
            endUserContactId: bidData.endUser.endUserContactId,
            endUserNumber: bidData.endUser.endUserId,
            everestEndUserId: everestEndUserId ?? '',
            faxNumber: '',
            firstName: bidData.endUser.firstName,
            fullAddress: bidData.endUser.fullAddress,
            fullName: bidData.endUser.fullName,
            ingramEndUserId: bidData.endUser.endUserId,
            isNewEndUser: false,
            lastName: bidData.endUser.lastName,
            line1: bidData.endUser.addressLine1,
            line2: bidData.endUser.addressLine2,
            phoneNumber: bidData.endUser.phone,
            postalCode: bidData.endUser.postalCode,
            stateName: bidData.endUser.stateName,
          }
        : {
            city: bidData.AffiliatedEndUserData.city,
            companyName: bidData.AffiliatedEndUserData.endUserAffiliationName,
            countryCode: bidData.AffiliatedEndUserData.country,
            countryName: bidData.AffiliatedEndUserData.country,
            email: '',
            endUserAcopId: '',
            endUserAddressSeqId: '',
            endUserAffiliationId:
              bidData.AffiliatedEndUserData.endUserAffiliationId?.toString(),
            endUserContactId: '',
            endUserNumber:
              bidData.AffiliatedEndUserData.endUserID !== 0
                ? bidData.AffiliatedEndUserData.endUserID?.toString()
                : '',
            everestEndUserId: everestEndUserId ?? '',
            faxNumber: '',
            firstName: '',
            fullAddress: '',
            fullName: '',
            ingramEndUserId:
              bidData.AffiliatedEndUserData.endUserID !== 0
                ? bidData.AffiliatedEndUserData.endUserID?.toString()
                : '',
            isNewEndUser: false,
            lastName: '',
            line1: '',
            line2: '',
            phoneNumber: '',
            postalCode: bidData.AffiliatedEndUserData.postalCode,
            stateName: bidData.AffiliatedEndUserData.state,
          },
    lineItemId: basketLineId,
    quantity: qty ?? 0,
    quoteNumber: quoteNumber || '',
    vendorCode,
  };

  if (bidData?.shouldCreateNewLine) {
    param['shouldCreateNewLine'] = true;
  }

  return param;
};

export const setQuoteEndUser = (endUser: any, quoteNumber?: string) => {
  const getStoredEnduser = () => {
    const endUserString = localStorage.getItem(`endUserData:${quoteNumber}`);

    const endUserLocalData = parseJSON(endUserString, '');

    if (!endUserLocalData) return {};

    if (endUserLocalData.CompanyName !== endUser?.companyName) {
      return {};
    }

    return endUserLocalData;
  };

  const storedEndUser = getStoredEnduser();
  const endUserData: any = {
    AcopTrackID: '',
    AddressLine1: endUser?.line1 || storedEndUser?.AddressLine1 || '',
    AddressLine2: endUser?.line2 || storedEndUser?.AddressLine2 || '',
    AddressLine3: endUser?.line3 || storedEndUser?.AddressLine3 || '',
    AddressLine4: endUser?.line4 || storedEndUser?.AddressLine4 || '',
    AddressSequenceId:
      endUser?.endUserAddressSeqId || storedEndUser?.AddressSequenceId || '',
    AgreementId:
      endUser?.endUserAgreementId || storedEndUser?.AgreementId || '',
    BillToCustomerNumber: null,
    City: endUser?.city || storedEndUser?.City || '',
    CmpAppUuid: endUser?.cmpAppUuid || storedEndUser?.CmpAppUuid || '',
    CmpEndCustomerId:
      endUser?.cmpEndCustomerId || storedEndUser?.CmpEndCustomerId || '',
    CompanyName: endUser?.companyName || storedEndUser?.CompanyName || '',
    ContactId: endUser?.endUserContactId || storedEndUser?.ContactId || '',
    Contacts: [
      {
        AddressLine1: endUser?.line1 || storedEndUser?.AddressLine1 || '',
        AddressLine2: endUser?.line2 || storedEndUser?.AddressLine2 || '',
        AddressLine3: endUser?.line3 || storedEndUser?.AddressLine3 || '',
        AddressLine4: endUser?.line4 || storedEndUser?.AddressLine4 || '',
        AliasName: null,
        City: endUser?.city || storedEndUser?.City || '',
        CompanyName: endUser?.companyName || storedEndUser?.CompanyName || '',
        ContactId: endUser?.endUserContactId || storedEndUser?.ContactId || '',
        CountryCode: endUser?.countryName || storedEndUser?.CountryCode || '',
        Email: endUser?.email || storedEndUser?.Email || '',
        EndUserNumber:
          endUser?.endUserNumber || storedEndUser?.EndUserNumber || '',
        Extension: '',
        FaxNumber: endUser?.faxNumber || storedEndUser?.FaxNumber || '',
        HouseNumber: endUser?.houseNumber || storedEndUser?.HouseNumber || '',
        LanguageKey: null,
        Name1: null,
        Name2: null,
        Name3: null,
        Name4: null,
        PhoneNumber: endUser?.phoneNumber || storedEndUser?.PhoneNumber || '',
        PostalCode: endUser?.postalCode || storedEndUser?.PostalCode || '',
        ResellerNumber: null,
        SearchTerm1: null,
        SearchTerm2: null,
        State: endUser?.stateName || storedEndUser?.State || '',
        Title: null,
      },
    ],
    ContractId: endUser?.endUserContractId || storedEndUser?.ContractId || '',
    Country: endUser?.countryName || storedEndUser?.Country || '',
    CountryCode: endUser?.countryCode || storedEndUser?.CountryCode || '',
    DirectShipGroupLineAddressId:
      endUser?.directShipGroupLineAddressId ||
      storedEndUser?.DirectShipGroupLineAddressId ||
      '',
    DirectShipGroupLineContactId:
      endUser?.directShipGroupLineContactId ||
      storedEndUser?.DirectShipGroupLineContactId ||
      '',
    DirectShipGroupLineEndUserId:
      endUser?.directShipGroupLineEndUserId ||
      storedEndUser?.DirectShipGroupLineEndUserId ||
      '',
    Email: endUser?.email || storedEndUser?.Email || '',
    EndUserAcopId: endUser?.endUserAcopId || storedEndUser?.EndUserAcopId || '',
    EndUserAffiliationId:
      endUser?.endUserInfo?.endUserAffiliationId ||
      storedEndUser?.EndUserAffiliationId ||
      null,
    EndUserCustomerNumber: '',
    EndUserNumber: endUser?.endUserNumber || storedEndUser?.EndUserNumber || '',
    Extension1: '',
    FaxNumber: endUser?.faxNumber || storedEndUser?.FaxNumber || '',
    FullName: endUser?.fullName || storedEndUser.fullName || '',
    HouseNumber: endUser?.houseNumber || storedEndUser?.HouseNumber || '',
    Id: endUser?.ingramEndUserId || storedEndUser?.Id || '',
    IndustrySegmentation:
      endUser?.industrySegmentation ||
      storedEndUser?.IndustrySegmentation ||
      '',
    IngramEndUserId:
      endUser?.ingramEndUserId || storedEndUser?.IngramEndUserId || '',
    IsFavorite: null,
    IsUsSboDefaultEnduser: '',
    Name: endUser?.Name || storedEndUser?.Name || '',
    PendingApproval: false,
    PhoneNumber: endUser?.phoneNumber || storedEndUser?.PhoneNumber || '',
    PostalCode: endUser?.postalCode || storedEndUser?.PostalCode || '',
    SseuAddressSequenceId: null,
    SseuContactId: endUser?.sseuContactId || storedEndUser?.SseuContactId || '',
    SseuEndUserId: endUser?.sseuEndUserId || storedEndUser?.SseuEndUserId || '',
    State: endUser?.stateName || storedEndUser?.State || '',
    StateCode: endUser?.stateCode || storedEndUser?.StateCode || '',
    TaxExemptNumber: null,
  };

  if (endUserData.CompanyName) {
    localStorage.setItem(
      `endUserData:${quoteNumber}`,
      JSON.stringify(endUserData)
    );
  }
};
